import jquery from 'jquery'
import _ from 'lodash'

window.jQuery = window.$ = jquery
window._ = _
